import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationPreCheckAlertModel } from '../models/registration_pre_check_alert_model';

export type ToggleRefreshRegistrationPreCheckAlertCommand = (Refresh: boolean) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'toggleRefreshRegistrationPreCheckAlertCommand',
    (defineCommandORM: IDefineCommand, ngRegistrationPreCheckAlertModel: RegistrationPreCheckAlertModel) =>
      defineCommandORM('toggleRefreshRegistrationPreCheckAlertCommand', (deferred, refresh: boolean = false) => {
        ngRegistrationPreCheckAlertModel.write({
          ...ngRegistrationPreCheckAlertModel.read(),
          showRefresh: refresh
        });
        return deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pre_check/commands/toggle_refresh_registration_pre_check_alert_command.ts